import React from 'react';
import { Link } from 'react-router';
import DataTable from '../../DataTable';
import { inject, observer } from 'mobx-react';
// import { token } from "../../../libs/localStorage";
import TicketInfoTable from "./TicketInfoTable";
import Spinner from "../../Spinner";
import { getDisplayDate } from '../../../libs/date';
import moment from 'moment';

@inject('ticketStore', 'stationStore', 'userStore', 'ticketStatusStore', 'ticketReasonStore', 'ticketActionStore')
@observer
class TicketList extends React.Component {

  slug = 'monitoring/ticket/tabular';

  handleDelete = (idOrIds) => {
    this.props.ticketStore.removeItems(idOrIds);
  };

  render() {
    const {
      ticketStore,
      stationStore,
      userStore,
      ticketStatusStore,
      ticketReasonStore,
      ticketActionStore,
      ticketView
    } = this.props;

    if ((ticketStore.isLoading || stationStore.isLoading || userStore.isLoading || ticketStatusStore.isLoading || ticketActionStore.isLoading || ticketReasonStore.isLoading)) {
      return <Spinner />;
    }

    if (ticketView) return ticketView;

    let columns = [
      { key: "checkbox", label: <input type="checkbox" name="" value="" checked={ticketStore.allChecked} onChange={ticketStore.onChangeTicketSelectAll} /> },
      { key: 'ticket_id', label: 'Ticket Number' },
      { key: 'station_identifier', label: 'Station Identifier' },
      { key: 'station_name', label: 'Station Name' },
      { key: 'summary', label: 'Summary' },
      { key: 'status', label: 'Status' },
      { key: 'reason', label: 'Reason' },
      { key: 'action', label: 'Action' },
      { key: 'assigned_to_user.name', label: 'Assigned To', tooltip: 'email' },
      { key: 'duration', label: 'Last Message', sortable: true, value: 'durationValue' },
      { key: 'ticket_creation_date', label: 'Creation Date', sortable: true },
      { key: 'ticket_end_date', label: 'End Date', sortable: true },
      { key: 'open_duration_display', sortKey: 'open_duration', label: 'Open Duration', sortable: true },
    ];

    let items = ticketStore.filteredTickets.map((item) => {
      let station = stationStore.findById(item.station_id);
      let user = userStore.findById(item.assigned_to);
      let status = ticketStatusStore.findById(item.status_id),
        reason = ticketReasonStore.findById(item.reason_id),
        action = ticketActionStore.findById(item.action_id);

      let checked = ticketStore.checkedTicketIds.includes(item.id);

      return {
        id: item.id,
        ticket_id: <div>{item.id} {!!item.archived && <div className='chip' data-toggle='tooltip' title='Archived'>A</div>}</div>,
        station_identifier: station && station.identifier,
        station_name: station && <Link to={`/station/${station.id}/monitoring`}>{station.name}</Link>,
        summary: <Link to={`/monitoring/ticket/tabular/${item.id}/view`}>{item.summary || 'View'}</Link>,
        status: status && status.caption,
        reason: reason && reason.caption,
        action: action && action.caption,
        assigned_to: user && user.name,
        email: user && user.email,
        duration: item.last_log && item.last_log.log_date ? ticketStore.getDuration(item.last_log.log_date) : ticketStore.getDuration(item.generated_date),
        durationValue: item.last_log && item.last_log.log_date ? new Date(item.last_log.log_date).getTime() : new Date(item.generated_date).getTime(),
        checkbox: <input type="checkbox" name="" value="" checked={checked} onChange={() => ticketStore.onChangeTicketSelect(item)} />,
        ticket_creation_date: item.generated_date && getDisplayDate(item.generated_date),
        ticket_end_date: (!!item.archived && item.end_date) && getDisplayDate(item.end_date),
        open_duration: item.open_duration,
        open_duration_display: !item.open_duration ? '' : ticketStore.getDuration(null, item.open_duration).replace(' ago', '').replace('a ', '1 '),
        assigned_to_user: item.assigned_to_user,
      }
    });

    return (
      <div className='full-width'>
        <div className='ticket-list-map'>
          <div className='flex-grow overflow-x-scroll'>
            <DataTable
              data={items}
              slug={this.slug}
              columns={columns}
              onDelete={this.handleDelete}
              showSerialNo
              allowAdd
              allowEdit
              // allowDelete
              resource='maintenance'
              isLoading={ticketStore.isLoading || stationStore.isLoading || userStore.isLoading || ticketStatusStore.isLoading || ticketActionStore.isLoading || ticketReasonStore.isLoading}
            />
          </div>
          <div>
            <TicketInfoTable />
          </div>
        </div>
        {this.props.children && this.props.children}
      </div>
    );
  }
}

export default TicketList;



// WEBPACK FOOTER //
// ./src/components/Maintenance/Ticket/TicketList.js